// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"478":"f65a05c8","520":"1b3023d3"}[chunkId] + ".chunk.css";
};